import {Injectable, OnDestroy} from '@angular/core';
import {FormBuilder,} from '@angular/forms';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {DialogAction} from '../contracts/dialog.interface';

@Injectable()
export abstract class GenericDialogComponent implements OnDestroy {
  protected constructor(protected fb: FormBuilder, protected ref: DynamicDialogRef, protected config: DynamicDialogConfig) {}

  closeDialog(){
    this.ref.close({
      action: DialogAction.CLOSE,
    });
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
}

